import React, {useState, MouseEvent, useEffect} from 'react';
import {FormularioSede} from './FormularioSede';
import axios from 'axios';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {animateScroll as scroll} from 'react-scroll';
import {ModalesUbicacion} from '../RegistroEmpresas/ModalesUbicacion';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {SedeEmpresa} from '../RegistroEmpresas/SedeEmpresa';

export const ListadoSedes = (props) => {
	const [ModalEliminar, setModalEliminar] = useState(false);
	const [ModalUbiacion, setModalUbiacion] = useState(false);
	const [latitud, setLatitud] = useState();
	const [longitud, setLongitud] = useState();
	const [Ubicacion, setUbicacion] = useState({
		lat: latitud,
		lng: longitud,
	});
	const [RadioUbicacion, setRadioUbicacion] = useState(3000);
	const [isMostrar, setIsMostrar] = useState(true);
	const [isLoad, setIsLoad] = useState(true);

	const {empresa, sedes, get_sedes} = props;
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	const [pantallaCrear, setPantallaCrear] = useState(false);
	const [sedeModificar, setSedeModificar] = useState('');
	const [sedeId, setSedeId] = useState();

	useEffect(() => {
		scroll.scrollToTop();
	}, []);

	const abrirPantalla = (sede) => {
		setSedeModificar(sede);
		setIsMostrar(true);
		setIsLoad(false);
		setPantallaCrear(true);
	};

	const mapa = (lat, lng, radio) => {
		setUbicacion({
			lat: lat,
			lng: lng,
		});
		setRadioUbicacion(radio)
		setModalUbiacion(true);
		setIsMostrar(false);
		setIsLoad(false);
	};

	const abrirEliminarSede = (sede_id) => {
		setSedeId(sede_id);
		setModalEliminar(true);
	};

	
	const eliminarSede = () => {
		axios({
			method: 'delete',
			url: window.ipdirection + 'sedePrestador_Cliente/' + sedeId,
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			get_sedes();
			setModalEliminar(false);
		});
	};

	const crear = () => {
		setSedeModificar('');
		setIsMostrar(true);
		setIsLoad(true);
		setPantallaCrear(true);
	};

	return pantallaCrear === false ? (
		<div className='listaPacientes'>
			{/* <div className='separadorFormEmpresas' /> */}
			<div className='TipoServiciosEmpresa'>
				<div className='titleMisPacientes'>
					<div className='centradorLeft'>
						<div className='headTipoServ-registro'>
							<h2>Sedes de la empresa</h2>
						</div>
						<p className='info-seleciona-servcio sin-margen'>
							Añade información a cerca de la/s sede/s de la empresa.
						</p>
						<br />

						<div className='separadorPacientes' />
					</div>
					<div className='centradorRight'>
						<div className='centrador-Botones-Registro-Empresa'>
							<div
								className='button'
								onClick={() => crear()}
							>
								<b>Añadir Sede</b>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='separador' />
			{sedes.map((sede, index) => (
				<>
					<div className='MiPaciente'>
						<div className='fotoUsuario centrador'>
							<div className='nombreUsuario'>{sede.nombreSede}</div>
							<div className='fotoNombreUsuario centrador'>
								<div
									className='centrador button-añadir-serivicios-registro'
									onClick={() => {
										mapa(sede.lat, sede.lng, sede.radio);
										console.log('ListadoSede', Ubicacion.lat, Ubicacion.lng);
									}}
								>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='16'
										height='16'
										fill='currentColor'
										class='bi bi-geo-alt'
										viewBox='0 0 16 16'
									>
										<path d='M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z' />
										<path d='M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z' />
									</svg>
								</div>
							</div>
						</div>
						<div className='datosUsuario'>
							<div className='direccionUsuario'>
								<b>Cod. Postal: </b>
								{sede.codigoPostal}
							</div>
							<div className='direccionUsuario'>
								<b>Dirección: </b>
								{sede.direccion}
							</div>
						</div>
						<div className='datosUsuario'>
							<div className='direccionUsuario'>
								<b>Localidad: </b>
								{sede.localidad.nombre}
							</div>
							<div className='direccionUsuario'>
								<b>Provincia: </b>
								{sede.localidad.provincia.nombre}
							</div>
						</div>
						<div className='opciones-MisPaciente'>
							<div
								className='opcionRespuesta respuestaObligatoria'
								onClick={() => {
									abrirPantalla(sede);
								}}
							>
								<div className='centrador'>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='24'
										height='24'
										fill='currentColor'
										className='bi bi-pencil-square'
										viewBox='0 0 16 16'
									>
										<path d='M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z' />
										<path
											fillRule='evenodd'
											d='M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z'
										/>
									</svg>
								</div>
								<div className='centrador'>Modificar</div>
							</div>
							<div
								className='opcionRespuesta eliminarRespuesta'
								onClick={() => {
									abrirEliminarSede(sede.id);
								}}
							>
								<div className='centrador'>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='24'
										height='24'
										fill='currentColor'
										className='bi bi-trash'
										viewBox='0 0 16 16'
									>
										<path d='M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z' />
										<path
											fillRule='evenodd'
											d='M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z'
										/>
									</svg>
								</div>
								<div className='centrador'>Eliminar</div>
							</div>
						</div>
					</div>
					<div className='separador' />
				</>
			))}

			<Modal
				centered={true}
				isOpen={ModalEliminar}
			>
				<ModalHeader>
					<div className='titulo-modal'>Eliminar sede</div>
				</ModalHeader>
				<ModalBody>
					<div> ¿Desea eliminar esta sede? </div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador'>
						<div
							className='button borrarCuenta'
							onClick={() => setModalEliminar(false)}
						>
							<b>Cancelar</b>
						</div>
					</div>
					<div className='centrador'>
						<div
							className='button'
							onClick={() => eliminarSede()}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
			<ModalesUbicacion
				ModalUbiacion={ModalUbiacion}
				setModalUbiacion={setModalUbiacion}
				Ubicacion={Ubicacion}
				setUbicacion={setUbicacion}
				RadioUbicacion={RadioUbicacion}
				setRadioUbicacion={setRadioUbicacion}
				setLatitud={setLatitud}
				setLongitud={setLongitud}
				isMostrar={isMostrar}
				setIsMostrar={setIsMostrar}
				isLoad={isLoad}
				setIsLoad={setIsLoad}
			/>
		</div>
	) : (
		<FormularioSede
			setPantallaCrear={setPantallaCrear}
			empresa={empresa}
			Usuario={Usuario}
			get_sedes={get_sedes}
			sedeModificar={sedeModificar}
			isMostrar={isMostrar}
			isLoad={isLoad}
		/>
	);
};
